import React from 'react';

import lodash from 'lodash';
import Product from './Product';
import { useWindowSize } from './lib/useWindowSize';
import type { ProductData } from './types';
const ProductRows = ({ products }) => {
  const colCount = useWindowSize()[0] < 1200 ? 3 : 4;
  const rows = lodash.chunk(products, colCount) as ProductData[][];
  return (
    <div className='all-products-product-rows'>
      {rows.map((row, rowIndex) => (
        <div className='row' key={rowIndex}>
          {row.map((product, colIndex) => (
            <Product
              productIndex={`${rowIndex}-${colIndex}`}
              product={product}
              key={product.productId}
              showAddToCartButton={true}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default ProductRows;
